
import Vue from 'vue'
import Vuex from 'vuex'

import LogRocket from 'logrocket'
import createPlugin from 'logrocket-vuex'
import cache from "./cache"
import editor from "./editor"
import toast from "./toast"

Vue.use(Vuex)

const emptyUser = {
  role: null,
}

const logrocketPlugin = createPlugin(LogRocket)

const router = new Vuex.Store({
  modules: {cache, editor, toast},
  plugins: [logrocketPlugin],
  state: {
    modal: null,
    toBind: null,
    loading: false,

    loadedUser: false,
    user: emptyUser,
    lightboxSources: null,
    lightboxType: "image"
  },
  mutations: {
    lightboxZoom(state, sources) {
      state.lightboxSources = sources || null
    },
    setLightboxType(state, type) {
      state.lightboxType = type;
    },
    setUser(state, user) {
      state.loadedUser = user ? true : false
      state.user = user || emptyUser
    },
    pushModal(state, data) {
      if (data) {
        state.modal = data.modal
        state.toBind = data.toBind
      } else {
        state.modal = null
        state.toBind = null
      }
    },
    loading(state, load) {
      if (load !== undefined) {
        state.loading = load
      } else {
        state.loading = !state.loading
      }
    },
  },
  getters: {
    isAdmin(state) {
      return state.user.role === 'ADMIN'
    },
    user(state) {
      return state.user
    },
  },
})

export default router
